import { connect } from 'react-redux';
import { getIsHotelOnly, getIsMobile } from 'src/store/view/selectors';
import { sendPageviewAction } from 'src/store/analytics/actions';
import { setVariant } from 'src/store/reviews/slice';
import { sendTargetadsPageviewAction } from 'src/store/targetAds/actions';
import { showPageAction } from '../../store/actions/view';
import {
  getHotelCurrentPage,
  getIsWhitelabel,
} from '../../store/selectors/view';
import { getLinkedHotels, getHotelRoulette } from '../../store/selectors/hotel';
import { getSearchParamsForUrl } from '../../store/selectors/searchParams';

import {
  getCashbackForCheapestRoom,
  getCashbackTypeForCheapestRoom,
} from '../../store/selectors/rooms';
import LayoutMobile from './LayoutMobile';

const mapStateToProps = (state) => ({
  page: getHotelCurrentPage(state),
  isRoulette: getHotelRoulette(state),
  linkedHotels: getLinkedHotels(state),
  searchParams: getSearchParamsForUrl(state),
  isWhitelabel: getIsWhitelabel(state),
  cashbackCount: getCashbackForCheapestRoom(state),
  cashbackType: getCashbackTypeForCheapestRoom(state),
  isHotelOnly: getIsHotelOnly(state),
  isMobile: getIsMobile(state),
});

const mapDispatchToProps = {
  showPage: showPageAction,
  sendPageview: sendPageviewAction,
  setVariantReviews: setVariant,
  sendTargetadsPageview: sendTargetadsPageviewAction,
};

export default connect(mapStateToProps, mapDispatchToProps)(LayoutMobile);
